import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromExtraPrismaActions from '../actions/extra-prisma.actions';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {WebshopRestService} from '../../services/api/webshop-rest.service';
import {ProductsResponse} from '../../models/shop/products-response.model';
import {ProductType} from '../../models/shop/product-type.model';

@Injectable()
export class ExtraPrismaEffects {
    private actions$ = inject(Actions);
    private productRestService = inject(WebshopRestService);
    /**
     * In case of SearchInvoicesAction we're going to call the InvoicesService and then
     * we'll post a LoadInvoicesCompleteAction to the reducer or in case of failure
     * LoadInvoicesFailAction
     *
     * @type {Observable<any>}
     */
    loadExtraPrisma$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromExtraPrismaActions.LoadExtraPrismaAction>(
                fromExtraPrismaActions.ExtraPrismaActionTypes.LOAD_EXTRAPRISMA
            ),
            map(action => action.payload),
            switchMap(productRequest =>
                this.productRestService.loadExtraPrisma(productRequest).pipe(
                    switchMap(data => {
                        const prodResp = new ProductsResponse({
                            ...data.returnObject,
                            ...{ type: ProductType.ExtraPrisma }
                        });
                        if (productRequest.page === 1) {
                            return [
                                new fromExtraPrismaActions.LoadExtraPrismaCompleteAction(prodResp),
                                new fromExtraPrismaActions.GetBatchFromCacheAction()
                            ];
                        } else {
                            return [new fromExtraPrismaActions.LoadExtraPrismaCompleteAction(prodResp)];
                        }
                    }),
                    catchError(error => of(new fromExtraPrismaActions.LoadExtraPrismaFailAction(error)))
                )
            )
        )
    );

    searchExtraPrisma$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromExtraPrismaActions.SearchShopAction>(
                fromExtraPrismaActions.ExtraPrismaActionTypes.SEARCH_EXTRAPRISMA
            ),
            map(action => action.payload),
            switchMap(productRequest => [
                new fromExtraPrismaActions.LoadExtraPrismaAction(productRequest)
            ])
        )
    );
    
}